// import StudentResults from "../../../../dummy_data/StudentResult.json";
import Layout from "../../../components/Layout";
import PageTitle from "../../../components/PageTitle";
import { useState, useEffect } from "react";
import TermBroadsheet from "../component/TermBroadsheet";
import SessionBroadsheet from "../component/SessionBroadsheet";
// import { CardSearch } from "../../../../components/CardSearch";
import TabContext from "@mui/lab/TabContext";
import {
  Grid
} from "@mui/material";
import Tab from "@mui/material/Tab";
import Tabs from "@mui/lab/TabList";
import { toast } from "react-toastify";
import TabPanel from "@mui/lab/TabPanel";
import Button from "../../../components/Button";
import { useUserState } from "../../../context/UserContext";
import useValidator from "../../../hooks/useValidator";
import useStyles from "../styles";
import { httprequest } from "../../../data/api";
import InputGroup from "../../../components/FormComponent/InputGroup";
import SelectGroup from "../../../components/FormComponent/SelectGroup";
import Modal from "../../../components/Modal";

// const TERM_ENDPOINT = "/api/v1/school-plan/terms";

const GET_SESSIONS = "/api/v1/school-plan/session";
const GET_CLASS_GRADES = "/api/v1/broad-sheet/";
const CLASSES_ENDPOINT = "/api/v1/class";
const OBTAINABLE_SCORE = "/api/v1/obtainable-score";
const TEACHERS_CLASS_ENDPOINT = "/api/v1/teacher/classes";
const TEACHER_CLASS_SUBJECT = "/api/v1/teacher/class-subject/";
const TEACHER_STUDENTS = "/api/v1/class/students/";
const CLASS_SUBJECT = "/api/v1/class-subject/";
const GET_All_STUDENTS = "/api/v1/class/students/";
const GET_SUBJECT_GRADES = "/api/v1/grade/";
const GRADING_SYSTEM = "/api/v1/grading-system";

const BroadSheet = () => {
  const classes = useStyles();
  const [value, setValue] = useState("1");
  const { userRole } = useUserState();
  const [teacherClassData, setTeacherClassData] = useState([]);
  const [isPageFetching, setIsPageFetching] = useState(false);
  const [activeSession, setActiveSession] = useState([]);
  // const [allSessions, setAllSessions] = useState([]);
  const [classesData, setClassData] = useState([]);
  const [aselectedTerm, setASelectedTerm] = useState("");
  const isTeacher = userRole?.role_type === "employee";
  const [studentResultValidator, showStudentResultValidator] = useValidator();
  const [obtainablescore, setObtainableScore] = useState([]);
  const [resultCreating, setResultCreating] = useState(false);
  const [classTestResult, setClassTestResult] = useState([]);
  const [calculatedGrade, setCalculatedGrade] = useState(null);
  const [autoCA, setAutoCA] = useState(false);
  const [selectedGrade, setSelectedGrade] = useState([]);
  const [caErrors, setCaErrors] = useState({});
  const [allGradingSystem, setAllGradingSystem] = useState([]);
  // const [selectedSessionTerms, setSelectedSessionTerms] = useState([]);
  const [allStudent, setAllStudents] = useState([]);
  const [resulttModal, setResultModal] = useState(false);
  const [allClassSubject, setAllClassSubject] = useState([]);
  const [classResultForm, setClassResultForm] = useState({
    subject_id: "",
    class_id: "",
    student_id: "",
    CA_scores: {},
    term_id: "",
    grade: "",
    total: "",
    // exam_score: "",
    CA_total: "",
    grading_system_id: "",
    grade_type: "manual"
  });

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  // const handleAddSubjectModal = () => {
  //   setResultModal(!resulttModal);
  // };

  /**
 * Finds the active term in the current session.
 * @type {Object}
 * @description This variable holds the term object where is_current is true,
 * from the activeSession's terms array.
 */
  const active_term_session = activeSession?.terms?.find((found_active_term) => found_active_term?.is_current === true);

  // Handle close Result Modal
  const handleCloseAddResultModal = () => {
    setResultModal(!resulttModal);
    setAutoCA(false);

    const initialCA = (obtainablescore?.[0]?.ca || []).reduce((acc, item) => {
      acc[item?.ca_type] = "";

      return acc;
    }, {});

    setClassResultForm((prev) => ({
      ...prev,
      CA_scores: initialCA,
      CA_total: "",
      grade: "",
      grading_system_id: "",
      total: "",
      // exam_score: "",
      student_id: ""
    }));
    setCaErrors({});
  };

  /**
   * Fetches all sessions from the server and updates the state.
   * @async
   * @function
   * @returns {Promise<void>}
   * @description Makes an asynchronous HTTP GET request to GET_SESSIONS endpoint,
   * updates the allSessions state with the response data, and sets the active session.
   */
  const getAllSessions = async () => {
    try {
      const res = await httprequest.get(GET_SESSIONS);
      // setAllSessions(res?.data?.data);
      setActiveSession(res?.data?.data?.find((active_session) => active_session?.current_session === true));
    } catch (err) {
      toast.error(err?.response?.message);
    }
  };

  /**
   * Fetches all class results for a specific class and term.
   * @async
   * @function
   * @param {string|number} classID - The ID of the class to get results for.
   * @param {string|number} termId - The ID of the term to get results for.
   * @returns {Promise<void>}
   * @description Makes an asynchronous GET request to GET_CLASS_GRADES endpoint,
   * updates the classGrades and filteredStudents state with the response data.
   */
  const handleGetAllClassResult = async (classID, termId) => {
    setIsPageFetching(true);
    try {
      const res = await httprequest.get(`${GET_CLASS_GRADES}${classID}?term_id=${termId}`);
      setIsPageFetching(false);
      setClassTestResult(res?.data?.data);
    } catch (err) {
      setIsPageFetching(false);
      toast.error(err?.response?.message);
    }
  };

  // Handle get student in a class
  const handleGetAllStudents = (class_id) => {
    httprequest.get(`${isTeacher ? TEACHER_STUDENTS : GET_All_STUDENTS}${class_id}`).then((res) => {
      setAllStudents(res?.data?.data);
    }).catch((err) => {
      toast.error(err?.response?.data);
    });
  };

  // Get All Subject for a Class
  const getAllSubjectForClass = async (class_id) => {
    try {
      const res = await httprequest.get(`${isTeacher ? TEACHER_CLASS_SUBJECT : CLASS_SUBJECT}${class_id}`);
      setAllClassSubject(res?.data?.data);
    } catch (err) {
      toast.error(err?.response?.data?.message);
    }
  };

  const filteredResults = Array.isArray(classTestResult)
    ? classTestResult.filter(
      (item) => item?.student?.id === classResultForm?.student_id &&
        item?.subject?.id === classResultForm?.subject_id
    )
    : [];

  /**
     * Fetches all physical classes from the server and updates the state.
     * @function
     * @returns {void}
     * @description This function makes an HTTP GET request to the CLASSES_ENDPOINT,
     * filters the response to only include physical classes, and updates the classData state.
     * It also manages the loading state with setIsPageFetching.
     */
  const getAllClasses = () => {
    setIsPageFetching(true);
    httprequest
      .get(isTeacher ? TEACHERS_CLASS_ENDPOINT : CLASSES_ENDPOINT)
      .then((res) => {
        const teacherClass = res?.data?.data?.map(item => item.class) || [];
        const physicalClasses = res?.data?.data?.filter(
          (data) => data?.class_type === "physical"
        );
        setIsPageFetching(false);
        setClassData(physicalClasses);
        setTeacherClassData(teacherClass);
      })
      .catch((err) => {
        toast.error(err?.response?.data?.message);
      });
  };

  /**
         * Fetches all obtainable scores from the API
         */
  const getAllObtainableScores = () => {
    // setIsLoading(true);
    httprequest
      .get(OBTAINABLE_SCORE)
      .then((res) => {
        setObtainableScore(res?.data?.data?.filter((scores) => scores?.session?.id === active_term_session?.session_id));
        // setIsLoading(false);
      })
      .catch((err) => {
        // setIsLoading(false);
        toast.error(err?.response?.data?.message);
      });
  };

  // CA SCores Input
  const handleTestScoreChange = (e, caType) => {
    const inputRaw = e.target.value;

    // Remove leading zeros: "010" -> "10"
    const inputValue = inputRaw.replace(/^0+(?=\d)/, "");

    // Get max obtainable for this caType
    const maxObtainable = obtainablescore?.[0]?.ca?.find((item) => item.ca_type === caType)?.score || 0;

    if (Number(inputValue) > maxObtainable) {
      setCaErrors((prev) => ({
        ...prev,
        [caType]: `${caType} cannot exceed ${maxObtainable}`
      }));

      return;
    } else {
    // Clear error for this CA type
      setCaErrors((prev) => ({
        ...prev,
        [caType]: ""
      }));
    }

    // Update CA_scores
    const updatedCA = {
      ...classResultForm.CA_scores,
      [caType]: inputValue
    };

    // Compute CA_total and total
    const CA_total = Object.values(updatedCA).reduce((sum, val) => sum + (Number(val) || 0), 0);
    const examScore = parseInt(classResultForm.exam_score) || 0;
    const totalScore = CA_total + examScore;

    // Determine grade
    let grade = "";
    if (selectedGrade?.grading) {
      const gradeDetails = selectedGrade.grading.find(
        (grade) => totalScore >= grade.min && totalScore <= grade.max
      );
      grade = gradeDetails ? gradeDetails.grade : "";
    }

    setClassResultForm({
      ...classResultForm,
      CA_scores: updatedCA,
      CA_total: String(CA_total),
      total: String(totalScore),
      grade
    });
  };

  const handleAutoCAChange = (e) => {
    const isChecked = e.target.checked;
    setAutoCA(isChecked);

    if (isChecked && filteredResults.length > 0) {
      const selectedResult = filteredResults[0];
      const updatedCAScores = { ...selectedResult.ca_scores };

      const totalCA = Object.values(updatedCAScores).reduce(
        (sum, score) => sum + (Number(score) || 0),
        0
      );

      setClassResultForm((prev) => ({
        ...prev,
        CA_scores: updatedCAScores,
        CA_total: String(totalCA),
        grade_type: "auto"
      }));
    } else {
    // Reset on uncheck
      setClassResultForm((prev) => ({
        ...prev,
        CA_scores: {},
        CA_total: "",
        grade_type: "manual"
      }));
    }
  };

  // Handle Get all Grading System
  const handleGetAllGradingSystem = () => {
    httprequest.get(GRADING_SYSTEM).then((res) => {
      setAllGradingSystem(res?.data?.data);
    }).catch((err) => {
      toast.error(err?.response?.data?.message);
    });
  };

  // Create Add Student Result
  const handlePostStudentResult = () => {
    if (studentResultValidator.allValid()) {
      setResultCreating(true);
      httprequest.post(GET_SUBJECT_GRADES, { ...classResultForm, term_id: aselectedTerm }).then((res) => {
        setResultCreating(false);
        toast.success(res?.data?.message);
        handleGetAllClassResult(value, aselectedTerm);
        handleCloseAddResultModal();
        setTimeout(() => {
          window.location.reload();
        }, 1000);
      }).catch((err) => {
        setResultCreating(false);
        toast.error(err?.response?.data?.message);
      });
    } else {
      showStudentResultValidator(true);
    }
  };

  const handleClassChange = (e) => {
    const class_value = e.target.value;
    getAllSubjectForClass(class_value);
    handleGetAllStudents(class_value);
    setClassResultForm({ ...classResultForm, class_id: class_value });
  };

  // Handle Select Grade system
  const handleGradeChange = (e) => {
    const selectedId = e.target.value;
    const selectedGradingSystem = allGradingSystem.find(
      (gradeSystem) => gradeSystem?.id === selectedId
    );

    setSelectedGrade(selectedGradingSystem);

    if (selectedGradingSystem && classResultForm?.total !== null) {
      const gradeDetails = selectedGradingSystem.grading.find(
        (grade) => classResultForm.total >= grade.min && classResultForm?.total <= grade.max
      );

      if (gradeDetails) {
        setCalculatedGrade(gradeDetails?.grade);
        // Update the grade in the subjectForm state
        setClassResultForm((prevForm) => ({
          ...prevForm,
          grade: gradeDetails?.grade,
          grading_system_id: selectedId
        }));
      } else {
        toast.error("Total does not fall within any grade range.");
        // Optionally clear the grade if no range matches
        setClassResultForm((prevForm) => ({
          ...prevForm,
          grade: "",
          grading_system_id: ""
        }));
      }
    }
  };

  /**
   * Fetches all terms for a specific session and updates the state.
   * @function
   * @param {string|number} Session_ID - The ID of the session to get terms for.
   * @returns {void}
   * @description Makes an HTTP GET request to TERM_ENDPOINT and filters the results
   * to only include terms matching the provided Session_ID.
   */
  // const getAllTerms = (Session_ID) => {
  //   httprequest
  //     .get(TERM_ENDPOINT)
  //     .then((res) => {
  //       setSelectedSessionTerms(res?.data?.data.filter((selected_term) => selected_term?.session_id === Session_ID));
  //     });
  //   .catch(() => {});
  // };

  // const handleSessionChange = (e) => {
  //   const Session_ID = e.target.value;
  //   setASelectedSession(e.target.value);
  //   getAllTerms(Session_ID);
  // };

  // Handle All Input Change
  const handleTextChange = (e) => {
    const { name, value } = e.target;
    const numericValue = parseFloat(value) || 0;

    // Copy form state
    const updatedForm = { ...classResultForm, [name]: value };

    // Check exam_score validity
    if (name === "exam_score") {
      const maxExam = obtainablescore?.[0]?.examination || 0;

      if (numericValue > maxExam) {
        toast.error(`Exam score cannot exceed ${maxExam}!`);

        // Reset to previous valid value
        updatedForm.exam_score = Number(classResultForm?.exam_score) || 0;
      }
    }

    // CA_total and exam_score to calculate the total score
    const caTotal = parseFloat(updatedForm.CA_total) || 0;
    const examScore = parseFloat(updatedForm.exam_score) || 0;

    // Add and check total
    const totalScore = caTotal + examScore;
    updatedForm.total = totalScore;

    if (totalScore > 100) {
      toast.error("Total score cannot exceed 100!");
    }

    // Calculate the grade
    let grade = "";
    if (selectedGrade?.grading) {
      const gradeDetails = selectedGrade.grading.find(
        (grade) => totalScore >= grade.min && totalScore <= grade.max
      );
      grade = gradeDetails ? gradeDetails.grade : "";

      // Update displayed grade
      setCalculatedGrade(grade);
    }

    updatedForm.grade = grade;

    // Update state
    setClassResultForm(updatedForm);
  };

  const handleStudentChange = (e) => {
    const { name, value } = e.target;
    setClassResultForm((prev) => ({ ...prev, [name]: value }));
    // getClassExamResult(value);
  };

  /**
   * @effect
   * @description When classesData or active_term_session changes, sets the first class
   * as default and fetches its results for the active term.
   * @deps classesData, active_term_session
   */
  useEffect(() => {
    const targetClasses = isTeacher ? teacherClassData : classesData;

    if (targetClasses?.length > 0 && active_term_session?.id) {
      const class_value = targetClasses[0]?.id;
      getAllSubjectForClass(class_value);
      handleGetAllStudents(class_value);
      // getAllTerms(active_term_session.session_id);
      handleGetAllClassResult(class_value, active_term_session.id);
      setClassResultForm((prev) => ({
        ...prev,
        class_id: class_value
      }));
    }
  }, [isTeacher, teacherClassData, classesData, active_term_session]);

  /**
   * @effect
   * @description When active_term_session changes, updates the selected term state.
   * @deps active_term_session
   */
  useEffect(() => {
    if (active_term_session?.id) {
      setASelectedTerm(active_term_session.id);
      // getAllTerms(active_term_session?.session_id);
      setClassResultForm((prev) => ({
        ...prev,
        term_id: active_term_session.id
      }));
      getAllObtainableScores();
    }
  }, [active_term_session]);

  /**
   * @effect
   * @description On component mount, fetches all sessions, terms, and classes.
   */
  useEffect(() => {
    getAllSessions();
    getAllClasses();
    handleGetAllGradingSystem();
  }, []);

  return (
    <Layout children={
      <>
        <PageTitle
          title="Academic Broadsheet"
          subtitle="See the breakdown of students results."
          button={
            <div>
              {/* <Button
                variant="primary"
                buttonSize="fluid"
                color="btndefault"
                onClick={handleAddSubjectModal}
                buttonName="Add Student Result"
              /> */}
            </div>
          }
        />

        <TabContext value={value}>
          <div className="tablist-container">
            <Tabs className="overide-tablist" onChange={handleChange} aria-label="">
              <Tab label="Session Broadsheet" value="1" />
              <Tab label="Term Broadsheet" value="2" />
            </Tabs>
          </div>
          <div>
            <TabPanel value="1" className="tabpanel-overide no_padding_0">
              <SessionBroadsheet />
            </TabPanel>
            <TabPanel value="2" className="tabpanel-overide no_padding_0">
              <TermBroadsheet />
            </TabPanel>
            {/* <TabPanel value="3" className="tabpanel-overide"><Apikeys /></TabPanel> */}
          </div>
        </TabContext>
        {/* Add Results */}
        <Modal
          title="Add Result"
          subtitle={
            <div>
                                Manually add your student’s result.
            </div>
          }
          modalContent={
            <>
              <Grid container spacing={2} className="input-padding">
                {/* <Grid item lg={6} md={6} sm={12} xs={12}>
                  {activeSession?.id && (
                    <SelectGroup
                      children={
                        <select
                          defaultValue={activeSession?.id}
                          onChange={handleSessionChange}
                          name="session"
                        >
                          <option value="">---Select---</option>
                          {allSessions?.map((sesh) => {
                            return (
                              <option key={sesh?.id} value={sesh?.id}>
                                {sesh?.session}
                              </option>
                            );
                          })}
                        </select>
                      }
                    />
                  )}
                </Grid> */}
                {/* <Grid item lg={6} md={6} sm={12} xs={12}>
                  {active_term_session?.id && (
                    <SelectGroup
                      children={
                        <select name="term" value={aselectedTerm}>
                          <option value="">---Select---</option>
                          {selectedSessionTerms?.map((data) => {
                            return (
                              <option key={data?.id} value={data?.id}>
                                {data?.term}
                              </option>
                            );
                          })}
                        </select>
                      }
                    />
                  )}
                </Grid> */}
                <Grid item lg={6} md={6} sm={12} xs={12}>
                  <SelectGroup
                    label="Class"
                    required
                    children={
                      <select name="class_id" onChange={handleClassChange}>
                        <option value="">{isPageFetching ? "Please wait" : "--- Select ---"}</option>
                        {(isTeacher ? teacherClassData : classesData)?.map((class_id) => {
                          return (
                            <option key={class_id.id} value={class_id?.id}>
                              {isTeacher ? class_id?.name : class_id?.class_name}
                            </option>
                          );
                        })}
                      </select>
                    }
                  />
                  {studentResultValidator.message("Class", classResultForm?.class_id, "required")}
                </Grid>
                <Grid item lg={6} md={6} sm={12} xs={12}>
                  <SelectGroup
                    label="Subject"
                    required
                    children={
                      <select name="subject_id" onChange={handleTextChange}>
                        <option value="">--- Select ---</option>
                        {allClassSubject?.map((subject) => {
                          return (
                            <option key={isTeacher ? subject?.subject?.id : subject.subject_id} value={isTeacher ? subject?.subject?.id : subject?.subject_id}>
                              {isTeacher ? subject?.subject?.name : subject?.subject_name}
                            </option>
                          );
                        })}
                      </select>
                    }
                  />
                  {studentResultValidator.message("Subject", classResultForm?.subject_id, "required")}
                </Grid>
                <Grid item lg={12} md={12} sm={12} xs={12}>
                  <SelectGroup
                    label="Students"
                    required
                    children={
                      <select name="student_id" onChange={handleStudentChange}>
                        <option value="">--- Select ---</option>
                        {allStudent?.map((student) => {
                          return (
                            <option key={student?.student?.student_id} value={student?.student?.student_id}>
                              {`${student?.student?.last_name} ${student?.student.first_name}`}
                            </option>
                          );
                        })}
                      </select>
                    }
                  />
                  {studentResultValidator.message("Student", classResultForm?.student_id, "required")}
                </Grid>
                <Grid item lg={12} md={12} sm={12} xs={12}>
                  <label>
                    <input
                      type="checkbox"
                      disabled={filteredResults.length === 0}
                      onChange={handleAutoCAChange}
                    />
                                        Add Score from CA Test
                  </label>
                </Grid>
                <Grid item lg={12} md={12} sm={12} xs={12}>
                  <Grid container spacing={2}>
                    {autoCA ? (
                      <>
                        {obtainablescore?.[0]?.ca?.map((item, index) => {
                          const existingValue = classResultForm?.CA_scores?.[item.ca_type];

                          return (
                            <Grid key={index} item lg={6} md={6} sm={12} xs={12}>
                              <InputGroup
                                label={item?.ca_type}
                                margin="normal"
                                required
                                placeHolder="Enter score"
                                inputType="number"
                                value={existingValue ?? ""}
                                onChange={(e) => handleTestScoreChange(e, item.ca_type)}
                              />
                              {/* {
                                studentResultValidator.message(
                                  item?.ca_type,
                                  classResultForm?.CA_scores?.[item?.ca_type],
                                  "required"
                                )} */}
                              {caErrors[item?.ca_type] && (
                                <p className={classes.printError}>
                                  {caErrors[item?.ca_type]}
                                </p>
                              )}
                            </Grid>
                          );
                        })}
                      </>
                    ) : (
                      <>
                        {obtainablescore?.[0]?.ca?.map((item, index) => (
                          <Grid key={index} item lg={6} md={6} sm={12} xs={12}>
                            <InputGroup
                              label={item?.ca_type}
                              margin="normal"
                              required
                              placeHolder="Enter score"
                              inputType="number"
                              onChange={(e) => handleTestScoreChange(e, item?.ca_type)}
                              value={classResultForm?.CA_scores?.[item?.ca_type] ?? ""}
                            />
                            {/* {studentResultValidator.message(
                              item?.ca_type,
                              classResultForm?.CA_scores?.[item?.ca_type],
                              "required"
                            )} */}
                          </Grid>
                        ))}
                      </>
                    )}
                  </Grid>
                </Grid>
                <Grid item lg={4} md={6} sm={12} xs={12}>
                  <InputGroup
                    label="Total CA Score"
                    margin="normal"
                    inputType="text"
                    required
                    inputName="CA_total"
                    value={classResultForm?.CA_total}
                    disabled
                  />
                  {studentResultValidator.message("CA Total", classResultForm?.CA_total, "required")}
                </Grid>
                <Grid item lg={4} md={6} sm={12} xs={12}>
                  <InputGroup
                    label="Exam Score"
                    margin="normal"
                    inputType="text"
                    required
                    inputName="exam_score"
                    onChange={handleTextChange}
                  />
                  {/* {studentResultValidator.message("Exam Score", classResultForm?.exam_score, "required")} */}
                </Grid>
                <Grid item lg={4} md={12} sm={12} xs={12}>
                  <InputGroup
                    label="Total Score"
                    margin="normal"
                    inputType="text"
                    required
                    inputName="total"
                    value={classResultForm?.total || 0}
                    disabled
                  />
                  {studentResultValidator.message("Total Score", classResultForm?.total, "required")}
                </Grid>
                <Grid item lg={9} md={12} sm={12} xs={12}>
                  <SelectGroup
                    label="Grade System"
                    required
                    children={
                      <select name="grading_system_id" onChange={handleGradeChange}>
                        <option value="">--- Select ---</option>
                        {allGradingSystem?.map((grade_system) => {
                          return (
                            <option key={grade_system?.id} value={grade_system?.id}>
                              {grade_system?.title}
                            </option>
                          );
                        })}
                      </select>
                    }
                  />
                </Grid>
                <Grid item lg={3} md={12} sm={12} xs={12}>
                  <SelectGroup
                    label="Grade"
                    required
                    children={
                      <select disabled value={calculatedGrade || ""} name="grade" onChange={handleTextChange}>
                        <option value="">--- Select ---</option>
                        {selectedGrade?.grading?.map((grade_type) => {
                          return (
                            <option key={grade_type?.grade} value={grade_type?.grade}>
                              {grade_type?.grade}
                            </option>
                          );
                        })}
                      </select>
                    }
                  />
                  {studentResultValidator.message("Grade", classResultForm?.grade, "required")}
                </Grid>
              </Grid>
            </>
          }
          modalFooter={
            <>
              <div>
                <Button
                  variant="primary"
                  buttonSize="full"
                  color="btndefault"
                  buttonName="Add Result"
                  onClick={handlePostStudentResult}
                  isLoading={resultCreating}
                />
              </div>
            </>
          }
          isopen={resulttModal}
          closeModal={handleCloseAddResultModal}
        />
        {/* <ToastContainer /> */}
      </>
    }
    />
  );
};

export default BroadSheet;
